import React from "react";
import PropTypes from "prop-types";
import "./EditingRestrictionNotice.css"; // assuming CSS is in the same folder

const EditingRestrictionNotice = ({ message = "Read-only", icon = "🔒" }) => {
  return (
    <div className="read-only-notice">
      <span className="read-only-icon">{icon}</span>
      <span className="read-only-text">{message}</span>
    </div>
  );
};

EditingRestrictionNotice.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.node,
  dir: PropTypes.oneOf(["ltr", "rtl", "inherit"]),
};

export default EditingRestrictionNotice;
